(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["algolia-autocomplete-default-template"] && !Shopify.designMode) return;
  try {
    
  const initTabSwitcher = function () {
    document.body.addEventListener('click', handleTabClick);
  };

  const handleTabClick = function (e) {
    if (!e.target.matches('.nl__aa-Default-Template__tab-title')) return;

    const clickedTab = e.target.closest('.nl__aa-Default-Template__tab-title');
    const tabsWrapper = e.target.closest('.nl__aa-Default-Template__tabs');

    if (!(clickedTab && tabsWrapper && clickedTab.matches('.active') === false)) return;
    const bodyId = clickedTab.id.replace('tab-head-', 'tab-body-');

    const tabBody = tabsWrapper.querySelector(`#${bodyId}`);
    if (!tabBody) return;

    tabsWrapper
      .querySelectorAll('.nl__aa-Default-Template__tab-body, .nl__aa-Default-Template__tab-title')
      .forEach((tab) => {
        tab.classList.remove('active');
      });
    clickedTab.classList.add('active');
    tabBody.classList.add('active');
  };

  initTabSwitcher();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["algolia-instantsearch-configuration"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const instantSearchContainer = document.querySelector('#algolia-shopify-instantsearch');

    const addInstantSearchEvents = function () {
      const instantsearchContainer = document.querySelector('#algolia-shopify-instantsearch');

      instantsearchContainer.addEventListener('click', () => {
        const item = event.target.closest('.ais-show-facets-button');

        if (item && instantsearchContainer.contains(item)) {
          instantsearchContainer.classList.add('ais-show-facets');
          document.documentElement.classList.add('js-drawer-open', 'lock-scroll');
        }
      });
    };

    const setFilterStickyPosition = function() {
      const header = document.querySelector('.site-header');
      const filtersContainer = document.querySelector('.ais-search-header');
      const headerHeight = header?.offsetHeight;

      if(headerHeight && filtersContainer) {
        filtersContainer.style.top = headerHeight - 1 + 'px'
      }
    }

    const initFiltersDrawer = function () {
      theme.FilterDrawer = new theme.Drawers('InstantSearchFiltersDrawer', 'instant-search-filters', true);

      // Need to simulate click on each header to close the collapsible which are opened by default
      const filtersDrawer = theme?.FilterDrawer?.drawer;

      if (filtersDrawer) {
        const filtersHeaders = filtersDrawer.querySelectorAll('.ais-facet--header');
        if (filtersHeaders && filtersHeaders.length > 0) {
          filtersHeaders.forEach((header) => {
            header.click();
          });
        }
      }

      if (theme.config.stickyHeader) {
        setFilterStickyPosition();

        window.on(
          'resize',
          theme.utils.debounce(500, setFilterStickyPosition)
        )
      }
    };

    document.addEventListener('algolia.hooks.initialize', function () {
      algoliaShopify.hooks.registerHook('beforeInstantSearchConfigurationOptions', function (options) {
        window.AlgoliaHelpers.mergeTranslations(options);

        return options;
      });

      algoliaShopify.hooks.registerHook('beforeInstantSearchStartAddWidgets', function() {
        const { configure } = window.algoliaShopify.externals.widgets;
        configureWidget = configure({
          facetingAfterDistinct: false,
        });

        return [configureWidget];
      });


      algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function (_defaultTemplate, data, html) {
        // Needs to be initialized AFTER 'InstantSearchMainTemplate' is rendered so we queue it!
        window.setTimeout(() => {
          initFiltersDrawer();
        }, 10);

        return html`
          <div class="ais-page">
            <h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1>
            <div class="ais-input">
              <div class="ais-search-box-container"></div>
              <div class="ais-input-button">
                <div class="ais-clear-input-icon"></div>
              </div>
            </div>
            <div style="display: none!important;" class="ais-facets-button">
              ${algoliaShopify.translations.showFilters}
            </div>
            <div class="ais-facets drawer drawer--left" id="InstantSearchFiltersDrawer" tabindex="-1">
              <div class="ais-facets__drawer-header">
                <h4 class="ais-h4">${algoliaShopify.translations.searchFiltersLabel}</h4>
                <button class="ais-close-facets-button js-drawer-close">
                  <svg
                    class="aa-ClearIcon"
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.293 6.707l5.293 5.293-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l5.293-5.293 5.293 5.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-5.293-5.293 5.293-5.293c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"
                    ></path>
                  </svg>
                </button>
              </div>
              <div class="ais-clear-refinements-container"></div>
              <div class="ais-current-refined-values-container"></div>
              ${algoliaShopify.config.app_blocks_dynamic_widgets_beta_enabled
                ? html` <div class="ais-dynamic-widgets-container"></div> `
                : data.facets.map(
                    (facet) =>
                      html`
                        <div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}">
                          <label
                            for="${facet.escapedName}"
                            class="ais-range-slider--header ais-facet--header ais-header"
                            >${facet.title}</label
                          >
                          <input
                            class="ais-dropdown-checkbox"
                            type="checkbox"
                            id="${facet.escapedName}"
                            name="dropdown"
                          />
                          <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
                        </div>
                      `
                  )}
            </div>
            <div class="ais-block">
              <div class="ais-search-header">
                <div class="ais-search-header__inner">
                  <div class="ais-facets-button__wrapper">
                    <button class="ais-show-facets-button btn btn--tertiary js-drawer-open-instant-search-filters">
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        role="presentation"
                        class="icon icon-filter"
                        viewBox="0 0 64 64"
                      >
                        <title>icon-filter</title>
                        <path
                          d="M48 42h10m-10 0a5 5 0 1 1-5-5 5 5 0 0 1 5 5ZM7 42h31M16 22H6m10 0a5 5 0 1 1 5 5 5 5 0 0 1-5-5Zm41 0H26"
                        />
                      </svg>
                      ${algoliaShopify.translations.showFilters}
                    </button>
                  </div>
                  <div class="ais-stats-container"></div>
                  <div class="ais-sort">
                    ${data.multipleSortOrders
                      ? html`
                          <span class="hidden-label">${algoliaShopify.translations.sortBy}</span>
                          <span class="ais-sort-orders-container"></span>
                        `
                      : html` ${algoliaShopify.translations.sortBy} ${algoliaShopify.translations.relevance} `}
                  </div>
                </div>
                <div class="ais-change-display">
                  <span class="ais-change-display-block ais-change-display-selected"
                    ><i class="fa fa-th-large"></i
                  ></span>
                  <span class="ais-change-display-list"><i class="fa fa-th-list"></i></span>
                </div>
              </div>
              <div class="ais-hits-container ais-results-as-block"></div>
            </div>
            <div class="ais-pagination-container"></div>
          </div>
        `;
      });

      const colorFilterMarkup = function (item, html) {
        const itemValueHandle = item?.value?.toLowerCase();
        return html`
          <span
            class="color-swatch color-swatch--filter color-swatch--${itemValueHandle} cs-${itemValueHandle}"
            title="${item.label}"
          >
            ${item.label}
          </span>
        `;
      };

      algoliaShopify.hooks.registerHook(
        'beforeInstantSearchFacetItemTemplate',
        function (_defaultTemplate, item, html) {
          const filterIsColor = item?.attribute === 'meta.basic_integration.color_family_pim';

          return html`
            <label class="${item.cssClasses.label}">
              ${item.type === 'disjunctive' &&
              (item.isRefined
                ? html` <input type="checkbox" class="${item.cssClasses.checkbox}" checked />
                    ${filterIsColor ? colorFilterMarkup(item, html) : html`<span class="tag__checkbox"></span>`}`
                : html`
                    <input type="checkbox" class="${item.cssClasses.checkbox}" />
                    ${filterIsColor ? colorFilterMarkup(item, html) : html`<span class="tag__checkbox"></span>`}
                  `)}
              <span class="label-count-wrapper">
                <span class="tag__text"> ${item.label} </span>
                <span class="${item.cssClasses.count} count-filter">
                  (${algoliaShopify.helpers.formatNumber(item.count)})
                </span>
              </span>
            </label>
          `;
        }
      );

      algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', function (_defaultTemplate, data, html) {
        return html`
          ${data.hasOneResult &&
          html` <span class="ais-stats--nb-results"> 1 ${algoliaShopify.translations.resultsFound} </span> `}
          ${data.hasManyResults &&
          html`
            <span class="ais-stats--nb-results">
              ${algoliaShopify.helpers.formatNumber(data.nbHits)} ${algoliaShopify.translations.resultsFound}
            </span>
          `}
        `;
      });

      algoliaShopify.hooks.registerHook(
        'beforeInstantSearchProductTemplate',
        function (_defaultTemplate, hit, html, components) {
          const itemTitleMap = window.AlgoliaHelpers.getBasicNetTitleParts(hit.title);

          // Prices formats
          const itemIsOnSale = window.AlgoliaHelpers.isOnSale(hit);
          const itemPriceVaries = window.AlgoliaHelpers.doesItemPriceVary(hit);
          const variantMinPrice = hit.variants_min_price;
          const variantCompareAtPriceMin = hit.variants_compare_at_price_min;
          const variantCurrency = hit.currency;
          const omnibusRaw = hit?.meta?.omnibus?.bestPrice;
          let itemOmnibus;

          if (omnibusRaw && typeof omnibusRaw === 'string') {
            itemOmnibus = JSON.parse(omnibusRaw);
          } else {
            itemOmnibus = omnibusRaw;
          }

          const displayOmnibusNotice = itemOmnibus?.amount > 0 && itemIsOnSale;
          const omnibusPrice = displayOmnibusNotice
            ? parseInt(itemOmnibus?.amount, 10) * 100
            : variantCompareAtPriceMin;

          let displayPrice = window.AlgoliaHelpers.wrapCurrency(algoliaShopify.formatMoney(variantMinPrice * 100, variantCurrency));
          const strikedPrice = window.AlgoliaHelpers.wrapCurrency(
            algoliaShopify.formatMoney(variantCompareAtPriceMin * 100, variantCurrency)
          );

          const omnibusNoticePrice = window.AlgoliaHelpers.wrapCurrency(algoliaShopify.formatMoney(omnibusPrice, variantCurrency));

          if (itemPriceVaries) {
            displayPrice = window.AlgoliaHelpers.addPriceVariesLabel(displayPrice);
          }

          const strikedPriceTemplate = strikedPrice
            ? html`<span class="ais-hit--SalePrice"
                >${(() => html`<span dangerouslySetInnerHTML=${{ __html: strikedPrice }} />`)()}</span
              >`
            : '';

          const sellingPriceTemplate = itemIsOnSale
            ? html`<span class="ais-hit--RegularPrice ais-hit--RegularPrice--on-sale"
                >${(() => html`<span dangerouslySetInnerHTML=${{ __html: displayPrice }} />`)()}</span
              >`
            : html`<span class="ais-hit--RegularPrice"
                >${(() => html`<span dangerouslySetInnerHTML=${{ __html: displayPrice }} />`)()}</span
              >`;

          const saleLabel = itemIsOnSale
            ? html`<span class="ais-hit--SaleLabel grid-product__tag grid-product__tag--sale"></span>`
            : ''; // ToDo: dynamic value for label

          const omnibusNotice = displayOmnibusNotice
            ? html`<div class="ais-hit--ItemContentPricePrevious">
                <span class="ais-hit--OmnibusNotice grid-product__notice--omnibus">
                  ${(() => html`<span dangerouslySetInnerHTML=${{ __html: omnibusNoticePrice }} />`)()}</span
                >
              </div>`
            : '';

          return html`
            <div
              class="ais-hit ais-product grid-product__content grid__item grid-product"
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              data-handle="${hit.handle}"
              data-distinct="${hit._distinct}"
              data-variant-id="${hit.objectID}"
              data-product-id="${hit.id}"
              onClick="${(e) => {
                // Prevent redirection when clicking on wishlist button (if you have one in your template)
                if (e.target.closest('.bn-wishlist-icon')) {
                  e.stopPropagation();
                  e.stopImmediatePropagation();
                }

                algoliaShopify.helpers.handleItemClick(hit);
              }}"
            >
              ${saleLabel}
              <div class="ais-hit--picture-mask">
                <img
                    class="ais-hit--picture"
                    src="${algoliaShopify.helpers.largeImage(hit)}"
                    alt="${hit.title} - ${hit.variant_title}"
                />
                ${(function () {
                  const res = fetch(`${Shopify.routes.root}products/${hit.handle}?sections=secondary-image`)
                    .then((res) => res.json())
                    .then((data) => {
                      const currentProduct = instantSearchContainer.querySelector(`[data-product-id="${hit.id}"]`);

                      if (currentProduct && data['secondary-image']) {
                        const aisHitPicture = currentProduct.querySelector('.ais-hit--picture-mask');
                        if (!aisHitPicture) return;

                        const aisSecondaryPicture = aisHitPicture.querySelector('.grid-product__secondary-image');
                        if (aisSecondaryPicture) return; // Avoid adding multiple times the secondary image on re-render

                        const secondaryImage = document.createElement('div');
                        secondaryImage.innerHTML = data['secondary-image'];
                        const secondaryImageElement = secondaryImage.querySelector('.grid-product__secondary-image');

                        if (!secondaryImageElement){
                          console.warn('Algolia InstantSearch: Could not find a secondary image for product', hit);
                          return;
                        }

                        secondaryImageElement?.querySelector('image-element')?.classList?.add('aos-animate'); // Added for animation on hover

                        aisHitPicture.appendChild(secondaryImageElement);
                      }
                    });
                })()}
              </div>

              <div class="ais-hit--details">
                <p class="ais-hit--title">
                  <a
                    class="grid-product__link"
                    data-algolia-index="${hit.index}"
                    data-algolia-position="${hit.productPosition}"
                    data-algolia-queryid="${hit.queryID}"
                    data-algolia-objectid="${hit.objectID}"
                    href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                    title="${itemTitleMap.title}"
                  >
                    ${itemTitleMap.title} ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
                  </a>
                </p>
                <p class="ais-hit--subtitle" title="${itemTitleMap.color}">${itemTitleMap.color}</p>
                <p class="ais-hit--price">
                  <div class="ais-hit--ItemContentPrice">
                    <div class="ais-hit--ItemContentPriceCurrent">
                      ${sellingPriceTemplate} ${itemIsOnSale && strikedPriceTemplate}
                    </div>
                    ${omnibusNotice}
                  </div>
                </p>
                <!-- Extra info examples - Remove the display: none to show them -->
                <p class="ais-hit--info" style="display: none">
                  ${
                    hit.sku &&
                    html` <span class="algolia-sku">${components.Highlight({ attribute: 'sku', hit })}</span> `
                  }
                  ${
                    hit.barcode &&
                    html` <span class="algolia-barcode">${components.Highlight({ attribute: 'barcode', hit })}</span> `
                  }
                  ${hit.weight && html` <span class="algolia-weight">${hit.weight}</span> `}
                  ${!hit.taxable && html` <span class="algolia-taxable">${algoliaShopify.translations.taxFree}</span> `}
                </p>
                <!-- Tags example - Remove the display: none to show them -->
                <p class="ais-hit--tags" style="display: none">
                  ${hit?._highlightResult.tags?.map((tag) => html` <span class="ais-hit--tag">${tag.value}</span> `)}
                </p>
                ${
                  !hit._distinct &&
                  html`
                    <form
                      id="algolia-add-to-cart-${hit.objectID}"
                      style="display: none;"
                      action="/cart/add"
                      method="post"
                      enctype="multipart/form-data"
                    >
                      <input type="hidden" name="id" value="${hit.objectID}" />
                    </form>
                    <p class="ais-hit--cart">
                      ${hit.can_order
                        ? html`
                            <button class="ais-hit--cart-button" data-form-id="algolia-add-to-cart-${hit.objectID}">
                              ${algoliaShopify.translations.addToCart}
                            </button>
                          `
                        : html`
                            <button class="ais-hit--cart-button ais-hit--cart-button__disabled">
                              ${algoliaShopify.translations.outOfStock}
                            </button>
                          `}
                    </p>
                  `
                }
              </div>
            </div>
          `;
        }
      );
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
